import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "chip", "chipName", "chipLabel"]

  fill() {
    const name = this.inputTarget.value.trim()
    if (name === "") return this.chipTargets.at(-1).remove()

    this.chipNameTargets.at(-1).value = name
    this.chipLabelTargets.at(-1).textContent = name
    this.inputTarget.value = ""
    this.inputTarget.focus()
  }
}
